import { trackMove } from '@otto-ec/nexus-registry/pdp/tracking';

export const addMoveTrackingToAllReviewsButton = (rootElement: HTMLElement) => {
    const allReviewsButton = rootElement.querySelector('.js_cr_list-wrapper__all-review-button');
    if (allReviewsButton) {
        allReviewsButton.addEventListener('click', () => {
            trackMove({ ot_PageCluster: ['Artikeldetailseite'], review_Navigation: ['bottom'] });
        });
    }
};
